/* eslint-disable */
export default {
  // actions
  actions: {
    addDamage: 'Add',
    login: 'Login',
    select: 'Select',
    clear: 'Cleaning',
    continue: 'Continue',
    cancel: 'Cancel',
    import: 'Import',
    export: 'Export',
    exportAll: 'Export all',
    selectFile: 'Select file',
    search: 'Search',
    save: 'Save',
    delete: 'Delete'
  },
  downloadModal: {
    title: 'Downloading file',
    text:
      'The file may take several minutes to download, please do not leave the page.'
  },
  // component: furniture
  furniture: {
    title: 'Furniture',
    empty: {
      short: 'Missing loss reference',
      long:
        'To be able to add furniture damage, enter accident reference and the address.'
    },
    kindOfProperty: 'Property type',
    kindOfPropertyOptions: {
      owner: 'Owner',
      renter: 'Render'
    }
  },
  // component: warrantyLayout
  warrantyLayout: {
    registerSinister: 'Save claim',
    newSinister: 'New claim',
    registeredDamages:
      '0 x Damage saved | 1 x Damage saved | {count} x Damages saved',
    modals: {
      newSinister: {
        title: 'New claim. Are you sure?',
        body: 'All date will be reset'
      }
    }
  },
  damageTypeCpi: {
    calendarLabel: {
      literal: 'Purchase date'
    },
    priceDamage: {
      literal: 'Purchase price'
    }
  },
  // component: warrantyRef
  warrantyRef: {
    sinisterRef: {
      literal: 'Claim reference'
    },
    secondaryRef: {
      literal: 'Alternative reference (optional)'
    }
  },
  // component: warrantyProps
  warrantyProps: {
    aboutProperty: 'Complementary information',
    address: {
      literal: 'Address',
      placeholder: 'Enter address'
    },
    zipCode: {
      literal: 'Postcode'
    },
    propertyType: {
      literal: 'Type of Property',
      options: {
        appartment: 'Appartment',
        maison: 'House',
        local_commercial: 'Commercial premise'
      }
    },
    residentType: {
      literal: 'Type of residence',
      options: {
        propietarie: 'Owner',
        locataire: 'Renter',
        propietarie_non_occupant: 'Lessor'
      }
    },
    moreThanTwoYears: {
      literal: 'Age of property',
      options: {
        less: 'Less than 2 years',
        more: 'More than 2 years'
      }
    },
    map: {
      empty: {
        title: 'No address',
        text: 'May you add a valid address?'
      }
    },
    nameApplicant: {
      literal: 'Name of insured',
      placeholder: 'Enter the name'
    },
    formsList: 'Forms',
    fnolIdsList: 'Contract',
    userIdsList: 'User type',
    buttonLink: {
      literal: 'Generate user link'
    },
    modalLink: {
      buttonGenerateLink: 'Generate a link',
      buttonCancel: 'Cancel',
      title: 'User link',
      alertMessage: 'Additional information must be completed.',
      alertAction: 'Complete the additional information'
    },
    moreInfoModal: {
      buttonGenerateLink: 'Additional information',
      buttonCancel: 'Cancel',
      title: 'Supplementary information',
      send: 'Send',
      personalInfo: {
        title: '1. Personal Data',
        name: 'Name',
        surname: 'Surname',
        phone: 'Phone',
        city: 'City'
      },
      contractInfo: {
        title: '2. Contract',
        scoreAsk: 'Score Ask',
        options: {
          vert: 'Green',
          orange: 'Orange',
          rouge: 'Red'
        },
        isValid: 'Is the contract valid?',
        deductibles: 'Real estate deductibles (€)',
        allowance: 'Embellishment allowance (€)',
        furnitureAllowance: 'Furniture allowance (€)',
        swimmingPool: 'Option(s) taken out - Swimming pool',
        externalFittings: 'Option(s) subscribed to - External fittings'
      },
      verifications: {
        title: '3. Vérifications',
        beforeSinister:
          'No current claim at the same address with the same coverage that occurred within 15 days before or after this claim',
        GaG: 'Name of Gré à gré',
        ren: 'Name of Ren',
        cause: 'What was the cause of the loss'
      },
      modalInformation: {
        title: 'Missing information',
        literal: 'To create a link, you must first fill in the additional information.',
        literal2: 'Please complete this section before continuing.',
        cancel: 'Cancel',
        completeInformation: 'Complete info',
      }
    },
    optionsUserType: {
      insured: 'Generic Selfcare',
      professional: 'Selfcare BillMA Professional',
      billma_insured: 'Selfcare BillMA Insured',
      billma_agent: 'Selfcare Agent',
      billma_user: 'Selfcare BillMA',
      ren_professional: 'Selfcare Ren Professional',
      ren_insured: 'Selfcare Ren Insured'
    },
    clientPhoneNumber: 'Phone Number',
    clientEmail: 'Email',
    clientValidationType: 'Type of validation',
    countryCode: 'Country code',
    example: 'Example: ',
    requiredFields: {
      title: 'Required fields',
      body: 'Required fields not filled in'
    }
  },
  // component: warrantySticky
  warrantySticky: {
    analyze: 'Analyse',
    generateReport: 'Create repport',
    generateReportFnol: 'Description damages',
    materialListBtn: 'List of materials',
    smartReport: 'Smart Report',
    damageSummary: {
      title: 'Valorisation of goods',
      tableHead: {
        damages: 'Damages',
        greAGre: 'Settlement',
        reparationNetwork: 'Agreed network reparation',
        reparationExcept: 'External network reparation'
      },
      tableSubHead: {
        embellishments: 'Ornaments',
        immobilier: 'Property',
        mobilier: 'Furniture'
      },
      tableMain: {
        manpowerHours: 'Work time (hours)',
        manpowerCost: 'Work time (euros)',
        materialCost: 'Material',
        totalCost: 'Total',
        priceWithoutTaxes: 'Taxes ex.',
        priceWithTaxes: 'Taxes inc.'
      },
      description: {
        quantity: 'Quantity'
      }
    },
    damageCounters: {
      gag: 'Settlement',
      materials: 'Materials and furniture',
      estimatedTime: 'Estimated time',
      authorizedNetworkRepair: 'Agreed network reparation',
      artessianRepair: 'External network reparation',
      immediate: 'Immediate',
      difference: 'Differed',
      ensembleImage: 'Overall picture',
      presImage: 'Close up picture',
      totalPrice: 'Total price'
    },
    manPower: {
      title: 'Change of manpower cost',
      calculatePrice: 'Calculate cost',
      cancel: 'Cancel',
      setPrice: 'Fix the price'
    },
    materialList: {
      title: 'Materials and work time',
      manpowerTime: 'Work time (hours)',
      manpowerPrice: 'Work time (€)',
      manpowerTitle: 'Manpower cost',
      materials: 'Materials',
      gag: 'Payment settlement',
      downloadPDF: 'Download PDF',
      cancel: 'Cancel',
      send: 'Send'
    }
  },
  // component: login
  login: {
    title: 'Mes dommages',
    titleMA: 'MAValue',
    text: 'Your claim valorisation system',
    authenticationError: 'Login error',
    authenticationBlock: 'Login blocked, try it after a few minutes',
    authenticationOk: 'Successful login',
    sso_processing: 'Identity verification in progress...',
    sso_wait: 'Please wait a moment.',
    sso_error_title: 'Authentication error',
    sso_error_msg: 'An error occurred during SSO login. Please try again or contact your administrator.',
    inputs: {
      username: 'User name',
      password: 'Password'
    },
    login: 'Login'
  },
  // component: error
  error: {
    title: 'Mes Dommages',
    titleMA: 'MAValue',
    text: "The page you're searching for does not exist",
    btn: 'Back'
  },
  // component: adminLayout
  adminLayout: {
    modals: {
      import: {
        title: 'Import parameters',
        description:
          'Import a file in order to modify parameters. If the parameter does not exist, then il will be created. If the parameter already exist, data will be overode.'
      },
      export: {
        title: 'Export parameters',
        description: 'Select the group of garantee for wich you need to filter'
      }
    },
    filters: {
      warranty: 'Garantee group',
      subwarranty: 'Sub garantee group'
    },
    notifications: {
      importedFile: {
        title: 'File imported',
        body: 'Table is now uploaded'
      }
    }
  },
  // component: parameters (gagadmin)
  gagParameters: {
    title: 'Parámetros',
    table: {
      paramName: 'Nombre del parámetro',
      paramValue: 'Valor del parámetro',
      customizable: 'Editable'
    }
  },
  // component: repMat (gagadmin)
  gagRepMat: {
    title: 'Materiales de reparación',
    table: {
      rep_type_code: 'Código',
      rep_description: 'Descripción',
      rep_mat: 'Material',
      mat_format_sale: 'Formato de venta',
      dam_measure_unit: 'Unidad de medida',
      conv_unit_per_mat_measure: 'Unidad de conversión por medida de material',
      mat_unit_price: 'Precio',
      is_hours: 'Sólo horas',
      image: 'Imagen'
    }
  },
  // component: zipCode (gagadmin)
  gagZipCode: {
    title: 'Zip Codes',
    table: {
      dept_code: 'Codes',
      zip_code_min: 'Minimum zip code',
      zip_code_max: 'Maximum zip code',
      country: 'Country',
      clean_cost: 'Cost',
      displacement_hours: 'Displacement hours',
      coef: '*** coef',
      factmin: '*** factmin'
    }
  },
  // component: ajustage (gagadmin)
  gagAjustage: {
    title: 'Adjust by customer age',
    table: {
      interval_age_start: 'Min age',
      interval_age_end: 'Max age',
      age_coef: 'Coefficient'
    }
  },
  // component: userLimits (gagadmin)
  gagUserLimits: {
    title: 'Limits',
    table: {
      user: 'User',
      hour_price_max_limit: 'Max price per hour',
      hour_price_min_limit: 'Min price per hour'
    }
  },
  // component: salaries (gagadmin)
  gagSalaries: {
    title: 'Salaries',
    table: {
      zip_code: 'Zip Code',
      csp: '*** csp',
      salary_hour: 'Price per hour'
    }
  },
  // component: parameters (admin)
  parameters: {
    title: 'Parameters',
    table: {
      paramName: 'Name of parameter',
      paramValue: 'Value of parameter',
      customizable: 'Editable',
      type: 'Type'
    }
  },
  // component: reparations (admin)
  reparations: {
    title: 'Reparations',
    warrantyid: 'Garantee group',
    subcategory: 'Sub category',
    table: {
      repTypeCode: 'Reparation code',
      description: 'Description',
      type: 'Reparation type',
      surfaceUnit: 'Unit of measure',
      damagesType: 'Type of damage',
      priceCalcForm: 'Form price calculation'
    }
  },
  // component: coefficients (admin)
  coefficients: {
    title: 'Rates',
    table: {
      repCodeType: 'Reparation code',
      description: 'Description',
      matSRen: 'Mat_s_RIK',
      coefMat: 'Coef_mat',
      coefMo: 'Coef_mo',
      price: 'Price'
    }
  },
  // component: depreciations (admin)
  depreciations: {
    title: 'Depreciation',
    table: {
      repTypeCode: 'Reparation code',
      description: 'Description',
      years: 'Years',
      depreciationPerc: 'Reparation percentage'
    }
  },
  // component: transversalCosts
  transversalcosts: {
    title: 'Cross costs',
    table: {
      damageType: 'Type of damage',
      componentName: 'Component name',
      description: 'Description',
      costFormat: 'Cost of format',
      value: 'Value'
    }
  },
  // component: users
  users: {
    title: 'Users',
    newUser: 'New user',
    table: {
      username: 'Username',
      firstName: 'Name',
      lastName: 'Surname',
      email: 'E-mail',
      role: 'Role',
      company: 'Company'
    },
    modals: {
      newUser: {
        title: 'New user'
      },
      editUser: {
        title: 'Edit user'
      },
      deleteUser: {
        title: 'You are going to delete this user.',
        body: 'This action is irreversible. do you wish to continue?'
      },
      user: {
        fields: {
          firstName: 'Name',
          lastName: 'Surname',
          username: 'User name',
          email: 'Email',
          company: 'Company name',
          role: 'User role',
          password: 'Password',
          repeatPassword: 'Repeat password'
        }
      }
    },
    filters: {
      company: 'Filter by company',
      role: 'Filter by role'
    }
  },
  // component: forms
  adminForms: {
    filterLabel: 'Filter by form',
    import: {
      title: 'Import settings',
      description:
        'To add or modify parameters please import a file. If the parameter does not exist it will be created or modified otherwise.'
    },
    export: {
      title: 'Import settings',
      description:
        'To add or modify parameters please import a file. If the parameter does not exist it will be created or modified otherwise.'
    },
    toast: {
      success: 'The file was processed successfully',
      error: 'The file could not be processed'
    },
    modal: {
      title: 'Processing document',
      description:
        'This process may take a few minutes. Please do not close the application'
    }
  },
  // component: small device modal
  smDevModal: {
    title: 'Invalid screen resolution',
    text:
      'The content you try to load is not compatible with your screen resolution. Please retry from a device whose resolution is higher than 1024 pixels.'
  },
  // notification
  notifications: {
    error: {
      0: {
        title: 'Error',
        body: 'Run time error'
      },
      400: {
        title: 'Mandatory field left',
        body: 'Please look at the information left'
      },
      500: {
        title: 'Error',
        body: 'Generic error'
      },
      409: {
        title: 'Claim id error',
        body: 'The claim identification already exists'
      },
      title: 'Error',
      body: 'Run time error'
    },
    addDamage: {
      title: 'Damage created',
      body: 'Damage correctly created'
    },
    newSinister: {
      title: 'New claim',
      body: 'Claim identification modified'
    },
    deleteDamage: {
      title: 'Damage removed',
      body: 'The damage has been correctly removed'
    },
    pdfDamages: {
      title: 'Report generated',
      body: 'Report correctly generated'
    },
    pdfMaterial: {
      title: 'Report generated',
      body: 'Report correctly generated'
    },
    mailPdfMaterial: {
      title: 'E-mail sent',
      body: 'E-mail correctly sent',
      error: {
        title: 'E-mail address invalid',
        body: 'Please enter a valid e-mail address'
      }
    },
    moCalculation: {
      title: 'Price updated',
      body: 'Report load ongoing'
    },
    changeLanguage: {
      title: 'Change language',
      body: 'Resend'
    },
    loadSinisterOK: {
      title: 'Claim loaded',
      body: 'Information uploaded'
    },
    loadSinisterKO: {
      title: 'Claim error',
      body: 'Error while loading the loss'
    },
    paramChanged: {
      title: 'Parameter changed',
      body: 'Table will be updated automatically'
    },
    user: {
      isRequired: {
        title: 'Missing fields',
        body: 'Please fill in all fields correctly'
      },
      isEmail: {
        title: 'Invalid email',
        body: 'The email entered is not valid'
      },
      isSamePassword: {
        title: 'Repeat password',
        body: 'Passwords do not match'
      },
      createdUser: {
        title: 'User created',
        body: 'The view is being updated'
      },
      modifiedUser: {
        title: 'User modified',
        body: 'The view is being updated'
      },
      deletedUser: {
        title: 'User deleted',
        body: 'The view is being updated'
      },
      error: {
        400: {
          title: 'Missing fields',
          body: 'Check the form fields'
        },
        500: {
          title: 'Error',
          body: 'An error has occurred'
        },
        409: {
          title: 'Identification error',
          body: 'The user already exists'
        }
      }
    }
  },

  // charts view
  charts: {
    mapTitle: 'Geolocation of claims',
    sinisterEvolutionTitle: 'Claims evolutionary',
    tableTitle: 'Data table',
    noDataAvailable: 'No data available',
    barChartDamageSubType: 'Average cost of type of guarantee',
    barChartDamageType: 'Average cost of type of damage',
    barChartCompensationType: 'Cost by type of compensation',
    pieChart: 'Distribution by subtype of damage',
    titleView: 'Dashboard',
    downloadData: 'Download data',
    fromDate: 'From',
    toDate: 'To',
    hintToDate: "Please select also the 'to Date'",
    hintFromDate: "Please select also the 'from Date'",
    tableHeadTitle: {
      company: 'Company',
      userName: 'User Name',
      l1: 'Level 1',
      l2: 'Level 2',
      l3: 'Level 3',
      l4: 'Level 4',
      q: 'q',
      averageCost: 'Average Cost',
      total: 'Total'
    },
    bubbleChartLegend: {
      price: 'Amount',
      damagesCount: 'Frequency'
    }
  },

  // search view
  search: {
    secondaryRef: 'Alternative reference',
    status: 'Status',
    gag: 'GAG',
    ren: 'REN',
    asp: 'ASP',
    createdDate: 'Created date',
    updatedDate: 'Updated date'
  },

  // tutorials view
  tutorials: {
    title: 'Tutorials',
    subtitle: 'Tutorial'
  },

  // Biens obiliers View
  biensMobiliers: {
    title: 'Movable property',
    searchEmpty: {
      search: 'Your research',
      notFound: 'did not get results'
    },
    text:
      'Use the search engine or navigate through the side menu to find the item you are looking for. You can also select between our most frequent categories'
  },

  // dashboard view
  dashboard: {
    GAG: {
      title: 'Gag and televaluations',
      downloadData: 'Download data',
      filters: {
        date: 'Period',
        startDate: 'Start date',
        endDate: 'Ending date',
        orderBy: 'Sort by',
        orderByOptions: {
          tmo: 'TMO',
          totalGAG: 'Total GAG',
          sinisterTotal: 'Total téléval',
          conversion: 'Conversion'
        }
      },
      kpis: {
        gag: 'GAG realized',
        TE: 'Televas performed',
        gagWeek: 'Gest with 1 GAG / week',
        gagSans: 'Gest without GAG'
      },
      table: {
        headers: {
          manager: 'Manager',
          conversion: 'Conversion',
          weeks: 'Weeks',
          evolution: 'Evolution',
          total: 'Total',
          totalGAG: 'Total GAG',
          totalTE: 'Total téléval',
          TMO: 'TMO'
        }
      }
    }
  },

  // common
  common: {
    surface: 'Surface',
    line: 'Lineal',
    distance: 'Distance',
    actualCalc: 'Calculation ongoing',
    selectOnTheMap: 'Measure on map',
    mapAction: 'Measure on map',
    mapActionLine: 'Measure on map',
    min: 'Minimum',
    max: 'Maximum',
    total: 'Total',
    recommended: 'Recommended',
    standard: 'Standard',
    noFile: 'No file selected',
    email: 'E-mail',
    search: 'Search',
    results: 'Results',
    noresults: {
      short: 'No result',
      long: 'There is no result for your search'
    },
    true: 'Yes',
    false: 'No',
    noOptions: 'There is no option',
    noSelected: 'No selection',
    agentView: 'Agent view',
    managerView: 'Manager view',
    unit: '0 units | x {count} unit | x {count} units'
  },
  empties: {
    noResults: {
      title: 'No result',
      descr: 'Use other searching parameters'
    }
  },
  // Area component
  areaMeasurement: {
    damageArea: 'Damage Area',
    measurementTipe: 'In Squaremeter',
    heightMeasurement: 'Height',
    widhtMeasurement: 'Width'
  }
}
